import { useState } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

const SEV = {
  alta: "border-l-red-600 bg-red-50/60",
  media: "border-l-amber-500 bg-amber-50/60",
  baja: "border-l-zinc-400 bg-zinc-50",
};

export const AlertsPanel = ({ alerts, onRefresh, loading }) => {
  const [filter, setFilter] = useState("todas");
  const list = (alerts || []).filter((a) => filter === "todas" || a.severidad === filter);
  return (
    <section className="panel p-6 lg:p-8" data-testid="alerts-list-container">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="eyebrow">Consistencia entre fuentes</p>
          <h2 className="panel-title mt-1 text-xl sm:text-2xl">Alertas ({alerts?.length ?? 0})</h2>
        </div>
        <div className="flex items-center gap-2">
          <select data-testid="alerts-filter-select" value={filter} onChange={(e) => setFilter(e.target.value)} className="border border-zinc-300 bg-white px-2 py-1.5 text-sm outline-none focus:border-orange-500">
            <option value="todas">Todas</option><option value="alta">Alta</option><option value="media">Media</option><option value="baja">Baja</option>
          </select>
          <button data-testid="alerts-refresh-button" onClick={onRefresh} className="btn-ghost border border-zinc-300 p-2" title="Recalcular">
            <RefreshCw size={14} className={loading ? "animate-spin" : ""} />
          </button>
        </div>
      </div>
      <div className="mt-5 max-h-[520px] space-y-3 overflow-auto pr-1">
        {list.length === 0 && <p className="text-sm text-zinc-400" data-testid="alerts-empty">Sin alertas. Carga estados financieros, balanza, Ekatena o CFDI para compararlos.</p>}
        {list.map((a, i) => (
          <article key={`${a.codigo}-${i}`} className={`border-l-4 p-4 ${SEV[a.severidad]}`} data-testid={`alert-card-${i}`}>
            <div className="flex items-start gap-2">
              <AlertTriangle size={15} className="mt-0.5 shrink-0 text-orange-600" />
              <div className="min-w-0">
                <p className="text-sm font-semibold">{a.titulo}</p>
                <p className="mt-1 text-xs text-zinc-600">{a.descripcion}</p>
                {a.condicion_precedente && <p className="mt-2 text-xs"><span className="font-semibold text-orange-700">CP sugerida:</span> {a.condicion_precedente}</p>}
              </div>
              <span className="ml-auto shrink-0 text-[10px] font-semibold uppercase tracking-wider text-zinc-500">Severidad {a.severidad}</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
